import { render, staticRenderFns } from "./SanctionsView.vue?vue&type=template&id=fa018eee&"
import script from "./SanctionsView.vue?vue&type=script&lang=js&"
export * from "./SanctionsView.vue?vue&type=script&lang=js&"
import style0 from "./SanctionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports